<template>
  <div class="header"
       :class="{'checked': isChecked}"
       ref="contentbox"
       @mouseenter="headMouseover"
       @mouseleave="headMouseleave">
    <div class="inner">
      <router-link to="/"
                   tag="div"
                   class="logo">
        <img v-if="isChecked"
             src="../assets/images/airsep/logo1.png"
             alt="">
        <img v-else
             src="../assets/images/airsep/logo2.png"
             alt="">
      </router-link>
      <div class="nav">
        <ul>
          <router-link to="/index"
                       tag="li"
                       class="child">
            <a href="javascript:;">首页</a>
          </router-link>
          <router-link to="/about"
                       tag="li"
                       class="child">
            <a href="javascript:;">关于我们</a>
          </router-link>
          <router-link to="/productDisplay"
                       tag="li"
                       class="child">
            <a href="javascript:;">产品展示</a>
          </router-link>
          <router-link to="/engineeringCases"
                       tag="li"
                       class="child">
            <a href="javascript:;">项目工程案例</a>
          </router-link>
          <router-link to="/serviceSupport"
                       tag="li"
                       class="child">
            <a href="javascript:;">项目服务支持</a>
          </router-link>
          <router-link to="/newsCenter"
                       tag="li"
                       class="child">
            <a href="javascript:;">新闻中心</a>
          </router-link>
          <router-link to="/contactUs"
                       tag="li"
                       class="child">
            <a href="javascript:;">联系我们</a>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import { routes } from '../router'
export default {
  name: 'Header',
  data () {
    return {
      pageName: 'Home',
      isChecked: false,
      scrollTop: 0,
      isProduct: false
    }
  },
  // computed: {
  //   routes () {
  //     return routes
  //   }
  // },
  watch: {
    $route (to, from) {
      // 产品中心添加 ‘router-link-active’
      this.productAddClass(this.$route)
      this.pageName = to.name
      this.headIsChecked()
    }
  },
  mounted () {
    this.productAddClass(this.$route)
    this.pageName = this.$route.name
    this.headIsChecked()
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    productAddClass (router) {
      const str = router.matched[0].path.substring(1)
      str === 'product' ? this.isProduct = true : this.isProduct = false
    },
    handleScroll () {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      this.scrollTop = scrollTop
      this.$emit('sendScrollTop', this.scrollTop)
      // console.log(this.scrollTop)
      if (this.pageName === 'Home') {
        if (this.scrollTop > 50) {
          this.isChecked = true
        } else {
          this.isChecked = false
        }
      }
    },
    headIsChecked () {
      if (this.pageName !== 'Home') {
        this.isChecked = true
      } else {
        this.isChecked = false
      }
    },
    headMouseover () {
      if (this.pageName === 'Home') {
        this.isChecked = true
      }
    },
    headMouseleave () {
      if (this.pageName === 'Home') {
        if (this.scrollTop > 50) {
          return false
        }
        this.isChecked = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.header {
  text-align: left;
  // background: #444;
  // width: 100%;
  width: calc(100vw);
  height: 76px;
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  // background: #A6A6A6;
  .inner {
    width: 1250px;
    margin: 0 auto;
    display: flex;
  }
  .logo {
    width: 300px;
    display: flex;
    cursor: pointer;
    img {
      // width: 60px;
      height: 59px;
      margin-right: 15px;
      margin-top: 10px;
    }
    .text {
      flex: 1;
      h1 {
        font-size: 20px;
        margin: 19px 0 13px;
      }
      p {
        font-size: 12px;
      }
    }
  }
  .nav {
    flex: 1;
    .child {
      display: block;
      float: left;
      margin: 0 18px;
      a {
        color: #fff;
        display: block;
        font-size: 18px;
        padding: 36px 3px 20px;
      }
      &.active,
      &:hover,
      &.router-link-active {
        border-bottom: 2px solid #00dcd4;
        a {
          color: #00dcd4;
        }
      }
      &:hover .list {
        display: block;
        animation: moverHeight 0.5s;
      }
      .list {
        display: none;
        width: 100%;
        height: 344px;
        background: #fff;
        position: absolute;
        top: 76px;
        left: 0;
        ul {
          width: 1200px;
          padding: 20px 0;
          margin: 0 auto;
          overflow: hidden;
          // display: flex;
          // flex-wrap: wrap;
          li {
            width: 400px;
            height: 76px;
            padding: 20px 30px 20px 10px;
            float: left;
            a {
              padding: 0;
              display: flex;
              // justify-content: center;
              align-items: center;
              display: flex;
              color: #6a6a6a;
              font-size: 16px;
              padding: 0;
              line-height: 18px;
            }
            a.router-link-active,
            a:hover {
              color: #00dcd4;
            }
            em {
              display: block;
              float: left;
              width: 36px;
              height: 36px;
              margin-right: 15px;
              background-repeat: no-repeat;
              background-position: center;
            }
            // span {
            //   display: block;
            //   color: #6A6A6A;
            //   font-size: 16px;
            //   padding: 0;
            //   line-height: 18px;
            // }
            .s1-icon {
              background-image: url("../assets/images/s1.png");
            }
            .s2-icon {
              background-image: url("../assets/images/s2.png");
            }
            .s3-icon {
              background-image: url("../assets/images/s3.png");
            }
            .s4-icon {
              background-image: url("../assets/images/s4.png");
            }
            .s5-icon {
              background-image: url("../assets/images/s5.png");
            }
            .s6-icon {
              background-image: url("../assets/images/s6.png");
            }
            .s7-icon {
              background-image: url("../assets/images/s7.png");
            }
            .s8-icon {
              background-image: url("../assets/images/s8.png");
            }
            .s9-icon {
              background-image: url("../assets/images/s9.png");
            }
            .s10-icon {
              background-image: url("../assets/images/s10.png");
            }
            .s11-icon {
              background-image: url("../assets/images/s11.png");
            }
            .s12-icon {
              background-image: url("../assets/images/s12.png");
            }
            .s13-icon {
              background-image: url("../assets/images/s13.png");
            }
          }
        }
      }
    }
  }
  &.checked {
    background: #fff;
    color: #00dcd4;
    animation: moverBg 0.3s;
    border-bottom: 1px solid rgba($color: #a6a6a6, $alpha: 0.5);
    .nav a {
      color: #434343;
    }
  }
}

@keyframes moverHeight {
  from {
    height: 0;
  }
  to {
    height: 344px;
  }
}

@keyframes moverBg {
  from {
    background: none;
  }
  to {
    background: #fff;
  }
}
</style>
